<template>
  <div>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="#">Steve's todos</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <router-link to="/" tag="li" exact active-class="active">
          <a class="nav-link">Home</a>
        </router-link>
        <router-link to="/Over" tag="li" exact active-class="active">
          <a class="nav-link">Over</a>
        </router-link>
      </ul>
    </div>
  </nav>
  <transition
    enter-active-class="animated fadeInDown"
    leave-active-class="animated fadeOutUp"
    mode="out-in">
      <router-view></router-view>
  </transition>

</div>
</template>

<script>
import Todos from './todos.vue';
import Over from './over.vue';

export default {
  name: 'app',
  data () {
    return {
    }
  },
  components: {
    appTodos: Todos,
    appOver: Over
  }
}
</script>

<style>
  .bg-light{
    background-color: rgba(255, 255, 255, 0.4) !important
  }

  .fadeInDown {
    animation-duration: 0.3s;
    animation-delay: 0s;
  }

  .fadeOutUp {
    animation-duration: 0.3s;
    animation-delay: 0.3s;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue